module.exports = __webpack_public_path__ + "img/big_1_71.73ba09ac.png";